export default __webpack_public_path__ + "f9e93be07340a1c809ad8f33c3a1f423.svg";